import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { Asignacion, ConfirmComponent, Context, GlobalInfo, Static, Tarea, TareaRol, TaskEvent, Usuario } from '@app/shared';
import { findIndex, remove, find } from 'lodash';
import { LocalDataSource } from 'ng2-smart-table';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { InternalTaskInformation } from '../shared/internal-task-information.config.service';
import { InternalTaskInformationDataService } from '../shared/internal-task-information.data.service';
import { HistoryAssignment } from '@app/forms/all/assignment-form/assignment-form.component';
import { ToastrService } from 'ngx-toastr';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

@Component({
  selector: 'iw-modify-responsable',
  templateUrl: './modify-responsable.component.html',
  styleUrls: ['./modify-responsable.component.scss']
})
export class ModifyResponsableComponent implements OnInit {
  // Contexto del formulario, es suministrado dinámicamente
  @Input() ctx: Context;
  // Evento para finalizar y cerrar la modal, es suministrado dinámicamente
  @Input() event: EventEmitter<any>;
  // Define si es una asignacion para finalizar la acarga de datos
  @Input() finishDataLoad = false;
  // Determina si el usuario en sesion es responsable de la tarea
  @Input() userResponsible = false;
  // Define si la tarea esta finalizada
  @Input() finishTask = false;
  // Tarea actual
  @Input() task: Tarea;
  // Tarea siguiente, a la que se le van asignar los responsables
  @Input() set nextTask(t: Tarea) {
    if (t && t.responsables && t.responsables.length) {
      this.responsibles = t.responsables;
    }
    this._nextTask = t;
  }
  // Define si hay una secundaria iniciada
  @Input() secondaryActive = false;
  // tipo del proceso de la tarea renderizada
  typeProcess: string;
  // Contiene el id del grupo seleccionado
  rolId = -1;
  // Determina si se esta realizando alguna petición al backend
  isLoading = false;
  // Determina cuando esta consultando los usuarios del grupo
  isLoadingUser = false;
  // Usuarios del rol(grupo) seleccionado
  users: Usuario[] = [];
  // Contiene el historial de asignaciones
  historyAssign: Asignacion;
  // Usuarios seleccionados para ser los responsables de la tarea (o eliminarlos)
  responsibles: Usuario[] = [];
  responsiblesDelete: Usuario[] = [];
  // Información global de la app
  gi: Partial<GlobalInfo>;
  // contiene la configuracion de la tabla
  settings = {};
  // Datos para llenar la tabla de historial de asignaciones
  source: LocalDataSource;
  // Datos para llenar la tabla dfe usuarios del grupo
  sourceUser: LocalDataSource;
  // contiene la configuracion de la tabla
  settingsUsers = {};
  // Referencia de la modal
  modalRef: BsModalRef;
  //Referencia para habilitar el selector de responsables para agregar
  addResponsable: boolean =  false;
  // validación para el botón asignar
  asignButton: boolean = false;
  // validación para el botón borrar
  deleteButton: boolean = false;
  //COPIA DEL OBJETO TASK
  internalTask: Tarea;
  // Valida si la tarea es de tipo asignación
  asign: boolean = false;
  // Modal de historial de asignaciones
  @ViewChild('templateHistoryAssign') private templateHistoryAssign: TemplateRef<any>;
  // Referencia al componente de confirmación
  @ViewChild('confirmFinish') private confirmFinish: ConfirmComponent;
  // Indica el cierre del componente de asignaciones
  @Output() closeAssignment = new EventEmitter<boolean>();
  // Tarea siguiente
  private _nextTask: Tarea;

  constructor(
    private modalService: BsModalService,
    private iti: InternalTaskInformationDataService,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    if (this.finishDataLoad) {
      this.userResponsible = true;
    }
    // Se inicia la configuracion de la tabla
    this.internalTask = Static.copyObjet(this.task);
    const configTable = new InternalTaskInformation();
    this.settings = configTable.getSettingsTableRejects();
    this.settingsUsers = configTable.getSettingsTableAssignment();
    if(this.task.tarea_tipo.nombre == "asignacion"){
      this.asign = true;
    }
    this.users = Static.copyObjet(this.task.responsables);
    this.sourceUser = new LocalDataSource(this.users);
    this.iti.getHistoryAssign(this.task.id).subscribe(res => {
      res.historial.sort((a, b) => b.version - a.version);
      this.historyAssign = res;
    });
  }

  /**
   * Consulta los usuarios del rol(grupo) seleccionado.
   *
   * @param {TareaRol} role
   * @memberof ModifyResponsableComponent
   */
  chooseRole(role: TareaRol) {
    if (this.rolId !== role.rol_id) {
      this.isLoadingUser = true;
      this.rolId = role.rol_id;
      this.iti.getRole(role.rol_id).subscribe(r => {
        if (r.rol_user && r.rol_user.length) {
          r.rol_user.forEach((user, i) => {
            r.rol_user[i]['select'] = this.isAssigned(user);
            r.rol_user[i]['nombre'] = user.first_name + ' ' + user.last_name;
          });
        }
        r.rol_user.forEach(rolUser => {
          let exists = false;
          this.users.forEach( user => {
            if(user.id == rolUser.id){
              user['select'] = this.isAssigned(user);
              exists = true;
            }
          })
          if(!exists){
            // this.users.push(rolUser);
            this.sourceUser.append(rolUser);
          }
        })  
        this.isLoadingUser = false;
      });
    }
  }

  /**
   * Asigna un usuario como responsable.
   *
   * @param {*} user
   * @memberof ModifyResponsableComponent
   */
  chooseUser(user: any) { 
    const userIndex = findIndex(this.users, {id: user.data.id});
    // Eliminar responable si existe
    const removed = remove(this.responsibles, u => {
      return u.id === user.data.id;
    });
    const removedDelete = remove(this.responsiblesDelete, u => {
      return u.id === user.data.id;
    });
    const aux = removed.length + removedDelete.length;
    if (!aux) {
      //Si el usuario ya viene asignado a la tarea, activa el botón de elimnar; por el contario, el de asignar
      let exists :  boolean = false;
      this.task.responsables.forEach(userSearch=>{
        if(userSearch.id == user.data.id){
          exists = true;
        }
      });
      if(exists){
        if(!this.responsiblesDelete.includes(user.data)){
          if(this.responsibles.length){
            this.responsibles.forEach(userSelect=>{
              userSelect['select'] = false;
            });
          }
          this.responsiblesDelete.push(user.data);
        }else{
          let index = this.responsiblesDelete.indexOf(user.data);
          this.responsiblesDelete.splice(index, 1);
        }
        this.responsibles.length = 0;
        this.asignButton = false;
        this.deleteButton = true;
      }else{
        if(!this.responsibles.includes(user.data)){
          if(this.responsiblesDelete.length){
            this.responsiblesDelete.forEach(userSelect=>{
              userSelect['select'] = false;
            });
          }
          this.responsibles.push(user.data);
        }else{
          let index = this.responsibles.indexOf(user.data);
          this.responsibles.splice(index, 1);
        }
        this.responsiblesDelete.length = 0;
        this.asignButton = true;
        this.deleteButton = false;
      }
      // this.responsibles.push(user.data);
      if (userIndex !== -1) {
        this.users[userIndex]['select'] = true;
        this.sourceUser.refresh();
      }
    }else {
      this.asignButton = false;
      this.deleteButton =  false;
      if (userIndex !== -1) {
        this.users[userIndex]['select'] = false;
        this.sourceUser.refresh();
      }
    }

  }

  /**
   * Valida si un usuario esta asignado.
   *
   * @param {Usuario} user
   * @returns {boolean}
   * @memberof ModifyResponsableComponent
   */
  isAssigned(user: Usuario): boolean {
    const userResponsible = find(this.responsibles, { id: user.id });
    if (userResponsible) {
      return true;
    }
    return false;
  }

  /**
   * Abre la modal de historial de asignaciones
   *
   * @memberof ModifyResponsableComponent
   */
  openFormCreateControl() {
    const historys: HistoryAssignment[] = [];
    if (this.historyAssign.historial && this.historyAssign.historial.length) {
      this.historyAssign.historial.forEach(history => {
        let responsibleAssignment = '';
        let responsiblerejection = '';
        let userAssignment = '';

        if (history.responsables && history.responsables.length) {
          history.responsables.forEach((responsible, index) => {
            if (index > 0) {
              responsibleAssignment += ' , ';
            }
            responsibleAssignment += responsible.nombres + ' ' + responsible.apellidos;
          });
        }

        if (history.usuarios_asignados && history.usuarios_asignados.length) {
          history.usuarios_asignados.forEach((userAssign, index) => {
            if (index > 0) {
              userAssignment += ' , ';
            }
            userAssignment += userAssign.nombres + ' ' + userAssign.apellidos;
          });
        }
        if (history.rechazo) {
          if (history.rechazo.responsable) {
            responsiblerejection += history.rechazo.responsable.nombres + ' ' + history.rechazo.responsable.apellidos;
          }
        }

        historys.push({
          fecha_registro: new Date(history.fecha_registro).toLocaleDateString(),
          fecha_finalizacion: new Date(history.fecha_finalizacion).toLocaleDateString(),
          responsable: responsibleAssignment,
          usuarios_asignados: userAssignment,
          fecha_rechazo: history.rechazo ? new Date(history.rechazo.fecha_rechazo).toLocaleDateString() : null,
          descripcion: history.rechazo ? history.rechazo.descripcion : null,
          responsable_rechazo: responsiblerejection,
        });

      });
    }

    this.source = new LocalDataSource(historys);
    this.source.refresh();

    this.modalRef = this.modalService.show(this.templateHistoryAssign, { class: 'modal-lg-personalized'});
  }

  /**
   * Evento que finaliza la tarea.
   *
   * @memberof ModifyResponsableComponent
   */
  finish(confimation?: boolean) {
    if (confimation && this.asignButton) {
      this.isLoading = true;
      const responsibles: number[] = [];
      this.responsibles.forEach(r => {
        responsibles.push(r.id);
      });
      this.iti.taskUpdate(this.task, 'cambiar_responsables', responsibles, true)
      .then(()=>{
        this.isLoading = false;
      })
      this.closeAssignment.emit(true);
    } if (confimation && this.deleteButton) {
      this.isLoading = true;
      const responsibles: number[] = [];
      this.responsiblesDelete.forEach(r => {
        responsibles.push(r.id);
      });
      this.iti.taskUpdate(this.task, 'cambiar_responsables', responsibles, false).then(()=>{
        this.isLoading = false;
      })
      this.closeAssignment.emit(true);
    }else {
        
    }
  }

  /**
   * Validad que la tarea se pueda finalizar
   *
   * @memberof ModifyResponsableComponent
   */
   finishConfirm() {
    if (this.responsibles.length && this.userResponsible && !this.finishTask && !this.secondaryActive) {
      this.confirmFinish.open();
    }else if (this.responsiblesDelete.length && this.userResponsible && !this.finishTask && !this.secondaryActive) {
      this.confirmFinish.open();
    }else {
      if (!this.userResponsible) {
        this.toastr.error('Usted no posee los permisos suficientes para ejecutar esta acción.', 'Permiso denegado');
      } else if (this.finishTask) {
        this.toastr.error('La tarea ya está finalizada.', 'Acción no permitida');
      } else if (this.secondaryActive) {
        this.toastr.error(
          'No se puede realizar esta acción debido a que se encuentra un procesos secundario en progreso.',
          'Acción no permitida'
        );
      } else if (!this.responsibles.length || !this.responsiblesDelete.length) {
          this.toastr.error('Debe seleccionar al menos un responsable.', 'Información incompleta');
      } else {
        this.toastr.error(
          'Lo sentimos ha ocurrido un error inesperado, inténtalo de nuevo más tarde.',
          'Error inesperado'
        );
      }
    }
  } 

  /**
   * Controla el evento al dar click en una de las acciones de la tabla
   * agregar, actualizar, modificar
   * Nota: este evento solo se ejecutara si la propieda "mode" de la configuracion de la tabla es external
   *
   * @param {*} data
   * @returns {*}
   * @memberof DataTableComponent
   */
  accion(data: any): any {
    // if(data.source){
    //   this.addResponsable = true;
    // }else {
    //   const responsables = [];
    //   responsables.push(data.data);
    //   this.iti.taskUpdate(this.task, 'cambiar_responsables', responsables);
    // }
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/utilitarios-management/utilitarios-flow/internal-task-information/modify-responsable/modify-responsable.component.ts